export default [
  {
    name: "Комиссии мыва",
    value: "comission"
  },
  {
    name: "Зарплаты и авансы",
    value: "salary"
  },
  {
    name: "Курьеры",
    value: "courier"
  },
  {
    name: "Маркетинг",
    value: "marketing"
  },
  {
    name: "Выводы собственника",
    value: "owner_withdrawals"
  },
  {
    name: "Выводы собственника 2",
    value: "owner_withdrawals_2"
  },
  {
    name: "Партнерские выплаты",
    value: "partner_payments"
  },
  {
    name: "Выводы рефералов",
    value: "referral_withdrawals"
  },
  {
    name: "Приобретение активов",
    value: "acquisition_of_assets"
  },
  {
    name: "IT расходы (сервера и домены)",
    value: "it_expenses"
  },
  {
    name: "Карты, дропы и аккаунты",
    value: "Cards_drops_and_accounts"
  },
  {
    name: "Штрафы",
    value: "penalties"
  },
  {
    name: "Другие",
    value: null
  }
];



// WEBPACK FOOTER //
// ./src/components/pages/Ledger/categories.js